import { useTranslation } from 'react-i18next';
import tw from 'twin.macro';

import { BookIcon } from '@icons/BookIcon';
import { CloseIcon } from '@icons/CloseIcon';
import { GARM_RISK_LEVEL } from '@insights_module/constants/garm';
import { Spacer } from '@components/Spacer';

const DefinitionContainer = tw.div`w-full h-full bg-neutral-background pt-3 px-4 pb-6 shadow-2xl rounded-md border-tertiary`;
const BlurBackground = tw.div`absolute top-0 left-0 w-full h-full bg-neutral-background backdrop-filter backdrop-blur-[4px] z-[-1] rounded-md`;
const Flex = tw.div`flex items-center justify-start`;
const FlexBetween = tw(Flex)`justify-between`;
const Title = tw.span`text-primary font-semibold text-sm`;
const LargeTitle = tw(Title)`text-[18px]`;
const Label = tw.span`font-semibold text-[11px] inline-block w-min whitespace-nowrap p-1 py-[2px] rounded-[4px] tracking-tight mr-3`;
const StyledP = tw.p`text-left text-muted text-sm leading-normal`;

const labelStyle = {
  [GARM_RISK_LEVEL.unrelated]: tw`bg-garm-unrelated-bg text-risk-unrelated`,
  [GARM_RISK_LEVEL.low]: tw`bg-risk-low-light text-risk-low`,
  [GARM_RISK_LEVEL.medium]: tw`bg-risk-medium-light text-risk-medium`,
  [GARM_RISK_LEVEL.high]: tw`bg-risk-high-light text-risk-high`,
  [GARM_RISK_LEVEL.floor]: tw`bg-risk-floor-light text-risk-floor`,
};

export const GarmDefinition = ({ category, level }: { category: string; level: string }) => {
  const { t } = useTranslation();
  return (
    <DefinitionContainer>
      <BlurBackground />
      <FlexBetween>
        <Flex>
          <BookIcon tw='stroke-primary w-8 h-6 mr-1 -ml-2' />
          <LargeTitle>{t('common.definitions')}</LargeTitle>
        </Flex>
        <CloseIcon tw='fill-text-and-icon-muted' />
      </FlexBetween>
      <Spacer direction='vertical' size='sm' />
      <div>
        <div>
          <Label css={[labelStyle[level]]}>{t(`insights.garm_risk_level.${level}`)}</Label>
          <Title>{t(`insights.garm_category.${category}`)}</Title>
        </div>
        <Spacer direction='vertical' size='sm' />
        <StyledP>{t(`insights.garm_overview.risk_level_description.${category}.${level}`)}</StyledP>
      </div>
    </DefinitionContainer>
  );
};
